import {
  APP_VERSION_PATH,
  computeAppVersionStatus,
  parseAppVersionInfo,
  resolveCurrentBuildId,
  type AppVersionInfo,
  type AppVersionStatus,
} from './appVersionCore'

export const CURRENT_APP_BUILD_ID = resolveCurrentBuildId(
  import.meta.env.VITE_APP_BUILD_ID,
  import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'dev',
)

export const CURRENT_APP_COMMIT = import.meta.env.VITE_APP_COMMIT ?? null

export class StaleAppVersionError extends Error {
  readonly currentBuildId: string
  readonly latestBuildId: string

  constructor(currentBuildId: string, latestBuildId: string) {
    super('Stale application version detected')
    this.name = 'StaleAppVersionError'
    this.currentBuildId = currentBuildId
    this.latestBuildId = latestBuildId
  }
}

export async function fetchLatestAppVersion(fetchImpl: typeof fetch = fetch): Promise<AppVersionInfo | null> {
  const response = await fetchImpl(APP_VERSION_PATH, {
    cache: 'no-store',
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
    },
  })

  if (!response.ok) return null
  return parseAppVersionInfo(await response.json())
}

export function getAppVersionStatus(latest: AppVersionInfo | null): AppVersionStatus {
  return computeAppVersionStatus(CURRENT_APP_BUILD_ID, latest)
}
